import request from 'utils/request';
import { statuses } from '../constants';
import { DictionaryDto } from './dictionary';

export interface StatusDto {
    code: string;
    description: string;
}

export function fetchCommonStatuses(): Promise<StatusDto[]> {
    return new Promise((resolve) => {
        resolve([
            {
                code: statuses.ACTIVE,
                description: 'Активный',
            },
            {
                code: statuses.ARCHIVED,
                description: 'Архив',
            },
            {
                code: statuses.CANCELLED,
                description: 'Отменен',
            },
            {
                code: statuses.DELETED,
                description: 'Удален',
            },
            {
                code: statuses.DRAFT,
                description: 'Черновик',
            },
            {
                code: statuses.PENDING,
                description: 'В ожидании',
            },
        ]);
    });
}

export interface StatusCommonDto extends DictionaryDto {
    priority: number | string;
    is_mass_sampling?: boolean;
}

export function initCommonStatus(): StatusCommonDto {
    return {
        status: '',
        description: '',
        code: '',
        id: '',
        priority: '',
    };
}

export function fetchAccessedStatuses(): Promise<StatusCommonDto[]> {
    return request({
        url: 'order-status/user',
        params: {
            sort: 'priority',
            size: 100,
        },
    }).then(({ data }) => data.content as StatusCommonDto[]);
}
